document.addEventListener('DOMContentLoaded', () => {

  const state = {
    currentStep: 1,
    currentProduct: null,
    productCache: {},
    activeRequestId: 0
  };

  // CUSTOM PIXEL TRACKING FUNCTION -->
  const stepsTracked = new Set();

  function publishQuizStep(step) {
    if (stepsTracked.has(step)) return;
    stepsTracked.add(step);

    if (typeof gtag !== 'function') return;

    gtag('event', `quiz_step_${step}`);
  }

  function publishQuizStartedCheckout() {
  if (typeof gtag !== 'function') return;

  gtag('event', 'quiz_started_checkout');
}
  // END CUSTOM PIXEL TRACKING FUNCTION -->

  const form = document.getElementById('subscription_form');
  const progressBar = document.getElementById('progressbar');

  if (!form) {
    console.log('Subscription form not found. Script terminated.');
    return;
  }

  const variantInput = document.getElementById('variant-id');
  const sellingPlanInput = document.getElementById('selling-plan-id');

  // ----------------------------
  // Helpers
  // ----------------------------
  const getSelectedOptions = () => ({
    optionOne: document.querySelector('input[name="option_one"]:checked')?.value,
    optionTwo: document.querySelector('input[name="option_two"]:checked')?.value,
    optionThree: document.querySelector('input[name="option_three"]:checked')?.value
  });

  const findVariant = (product, options) => {
    if (!product?.variants) return null;

    return product.variants.find(v =>
      v.option1 === options.optionOne &&
      v.option2 === options.optionTwo &&
      v.option3 === options.optionThree
    ) || null;
  };

  const fetchProduct = async (handle) => {
    if (state.productCache[handle]) return state.productCache[handle];

    const res = await fetch(`/products/${handle}.json`);
    if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);

    const data = await res.json();
    state.productCache[handle] = data.product;
    return data.product;
  };

  // ----------------------------
  // Progress Bar
  // ----------------------------
  function updateProgressBar(step) {
    document.querySelectorAll('#progressbar .step').forEach((stepElem, index) => {
      stepElem.classList.toggle('active', index < step);
    });
  }

  function updateStepActiveState(step) {
    document.querySelectorAll('#progressbar .step').forEach(stepElem => {
      const stepIndex = parseInt(stepElem.getAttribute('data-step'), 10);
      stepElem.classList.toggle('active', stepIndex <= step);
    });
  }

  function initializeProgressBar() {
    updateProgressBar(state.currentStep);
    updateStepActiveState(state.currentStep);
  }

  if (progressBar) initializeProgressBar();

// ----------------------------
  // Fieldset Navigation (Old jQuery Scroll Restored)
  // ----------------------------
  function navigateFieldset(forward = true) {
    const currentFs = document.querySelector(`fieldset:nth-of-type(${state.currentStep})`);
    const nextFs = forward ? currentFs?.nextElementSibling : currentFs?.previousElementSibling;

    if (!currentFs || !nextFs) return;

    currentFs.style.display = 'none';
    nextFs.style.display = 'block';

    state.currentStep = forward ? state.currentStep + 1 : state.currentStep - 1;

    // CUSTOM PIXEL TRACKING FUNCTION PUBLISH STEPS ---
    publishQuizStep(state.currentStep);

    updateProgressBar(state.currentStep);
    updateStepActiveState(state.currentStep);

    // RESTORED OLD RELIABLE SCROLL
    jQuery("html, body").animate({ scrollTop: 0 }, 500);
  }

  document.querySelectorAll('.next').forEach(btn =>
    btn.addEventListener('click', () => navigateFieldset(true))
  );

  document.querySelectorAll('.previous').forEach(btn =>
    btn.addEventListener('click', () => navigateFieldset(false))
  );

  // ----------------------------
  // Core Updates
  // ----------------------------
  function updateQuizVariants() {
    if (!state.currentProduct?.variants) return;

    const options = getSelectedOptions();
    if (!options.optionOne || !options.optionTwo || !options.optionThree) return;

    const matchedVariant = findVariant(state.currentProduct, options);
    if (matchedVariant) {
      variantInput.value = matchedVariant.id;
    }
  }

  async function updateAllPlanPrices() {
    const options = getSelectedOptions();
    if (!options.optionOne || !options.optionTwo || !options.optionThree) return;

    const plans = document.querySelectorAll('input[name="product_plan"]');

    for (const plan of plans) {
      const productHandle = plan.value;

      try {
        const product = await fetchProduct(productHandle);
        const matchedVariant = findVariant(product, options);

        if (!matchedVariant) continue;

        document
          .querySelectorAll(`.radio_option[data-product-handle="${productHandle}"]`)
          .forEach((option) => {
            const originalPriceElement = option.querySelector('.subscription-price');
            const discountedPriceElement = option.querySelector('.subscription-discounted-price');
            const discountPercentage = parseInt(option.getAttribute('data-discount'), 10);

            if (originalPriceElement) {
              originalPriceElement.textContent = `$${matchedVariant.price}`;
            }

            if (discountedPriceElement && discountPercentage) {
              const discountedPrice = matchedVariant.price * (1 - discountPercentage / 100);
              discountedPriceElement.textContent = `$${discountedPrice.toFixed(2)}`;
            }
          });

      } catch (error) {
        console.error(`Error updating price for plan: ${productHandle}`, error);
      }
    }
  }

  function updateSellingPlan() {
    const selectedPlan = document.querySelector('input[name="product_plan"]:checked');
    if (selectedPlan) {
      sellingPlanInput.value = selectedPlan.getAttribute('data-plan-id') || '';
    }
  }

  async function loadProductData(productHandle) {
    const requestId = ++state.activeRequestId;

    try {
      const product = await fetchProduct(productHandle);

      if (requestId !== state.activeRequestId) return;

      state.currentProduct = product;

      updateQuizVariants();
      updateAllPlanPrices();

    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  // ----------------------------
  // Direct to Checkout Logic (Final Stable Version)
  // ----------------------------
  let isSubmitting = false;

  const checkoutBtn = document.querySelector('.add-box-btn');

  function startOverlaySequence(petName) {
    const statusEl = document.getElementById('quiz-loading-status');
    const progressEl = document.querySelector('.quiz-loading-progress-inner');

    if (!statusEl || !progressEl) return;

    statusEl.style.transition = 'opacity 0.2s ease';
    progressEl.style.transition = 'width 0.6s ease';

    // Reset progress
    progressEl.style.width = '0%';
    void progressEl.offsetWidth;

    // Step 1
    statusEl.textContent = 'Matching size…';
    statusEl.style.opacity = '0.9';
    progressEl.style.width = '35%';

    // Step 2 (hold at 85%, never fake 100%)
    setTimeout(() => {
      statusEl.style.opacity = '0';
      setTimeout(() => {
        statusEl.textContent = `Picking toys just for ${petName}…`;
        statusEl.style.opacity = '0.9';
      }, 150);

      progressEl.style.width = '85%';
    }, 800);
  }

  function completeProgress() {
    const progressEl = document.querySelector('.quiz-loading-progress-inner');
    if (progressEl) {
      progressEl.style.width = '100%';
    }
  }

  if (checkoutBtn) {

    checkoutBtn.addEventListener('click', async () => {

      if (isSubmitting) return;
      isSubmitting = true;
      checkoutBtn.disabled = true;

      const overlay = document.getElementById('quiz-loading-overlay');
      const overlayStartTime = Date.now();

      const petName =
        document.querySelector('#dog-name')?.value?.trim() || "Your Dog";

      if (overlay) {
        const overlayName = document.getElementById('overlay-dog-name');
        if (overlayName) overlayName.textContent = petName;

        overlay.classList.add('active');
        startOverlaySequence(petName);
      }

      updateQuizVariants();
      updateSellingPlan();

      const variantId = Number(variantInput?.value);
      const sellingPlanId = Number(sellingPlanInput?.value);

      if (!variantId || !sellingPlanId) {
        if (overlay) overlay.classList.remove('active');
        checkoutBtn.disabled = false;
        isSubmitting = false;
        alert('Please complete all quiz steps before submitting.');
        return;
      }

      // CUSTOM PIXEL TRACKING FUNCTION QUIZ CHECKOUT STARTED ---
      publishQuizStartedCheckout();

      try {

        // 1️⃣ Clear cart properly
        const clearRes = await fetch('/cart/clear.js', {
          method: 'POST'
        });

        if (!clearRes.ok) throw new Error('Cart clear failed');

        // 2️⃣ Small buffer to avoid Shopify eventual consistency edge case
        await new Promise(resolve => setTimeout(resolve, 100));

        // 3️⃣ Add main item + bonus items (bulletproof)

        const selectedPlan = document.querySelector('input[name="product_plan"]:checked');

        let bonusVariants = [];

        if (selectedPlan) {
          const selectedOption = selectedPlan.closest('.radio_option');

          if (selectedOption && selectedOption.dataset.bonusVariants) {
            try {
              const parsed = JSON.parse(selectedOption.dataset.bonusVariants);
              if (Array.isArray(parsed)) {
                bonusVariants = [...new Set(parsed)]; // remove duplicates
              }
            } catch (e) {
              console.warn('Invalid bonusVariants JSON');
            }
          }
        }

        const rawName = document.querySelector('#dog-name')?.value?.trim();
        const birthdayValue = document.getElementById('birthday')?.value?.trim();
        const properties = {};

        if (rawName) {
          properties.Name = rawName;
        }
        if (birthdayValue) {
          properties.Birthday = birthdayValue;
        }

        const bundleId = `bundle_${Date.now()}_${Math.random().toString(36).slice(2,8)}`

        const items = [
          {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: {
              ...properties,
              _quiz_bundle_id: bundleId
            }
          }
        ];

        // Add each bonus variant safely
        bonusVariants.forEach(bonusId => {
          if (bonusId && !isNaN(bonusId)) {
            items.push({
              id: Number(bonusId),
              quantity: 1,
              properties: {
              _quiz_bundle_id: bundleId,
              _free_gift: "true"
              }
            });
          }
        });

        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!addRes.ok) throw new Error('Cart add failed');

        // 4️⃣ Only now complete progress
        completeProgress();

        // 5️⃣ Minimum visible time so animation never flashes
        const minDisplayTime = 2000;
        const elapsed = Date.now() - overlayStartTime;
        const delay = Math.max(minDisplayTime - elapsed, 0);

        setTimeout(() => {
          window.location.href = '/checkout';
        }, delay);

      } catch (error) {
        console.error('Checkout error:', error);

        if (overlay) overlay.classList.remove('active');

        checkoutBtn.disabled = false;
        isSubmitting = false;

        alert('Something went wrong. Please try again.');
      }

    });

  }

  // ----------------------------
  // Plan Change
  // ----------------------------
  document.querySelectorAll('input[name="product_plan"]').forEach(plan => {
    plan.addEventListener('change', async () => {
      const productHandle = plan.value;

      if (state.currentProduct?.handle === productHandle) {
        updateAllPlanPrices();
        updateSellingPlan();
        return;
      }

      await loadProductData(productHandle);
      updateSellingPlan();
    });
  });

  // ----------------------------
  // Radio Active Styling + Updates
  // ----------------------------
  document.querySelectorAll('input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const parentOption = radio.closest('.radio_option');

      if (parentOption && parentOption.parentElement) {
        parentOption.parentElement
          .querySelectorAll('.radio_option')
          .forEach(option => option.classList.remove('active'));

        parentOption.classList.add('active');
      }

      updateQuizVariants();
      updateAllPlanPrices();
    });
  });

  // ----------------------------
  // Dog Name Injection
  // ----------------------------
  const step1NextButton = document.querySelector('fieldset#step_1_content button.next.action-button');
  if (step1NextButton) {
    step1NextButton.addEventListener('click', () => {
      const petNameInput = document.querySelector('input#dog-name');
      const petName = petNameInput?.value?.trim() || "Your Dog";

      document.querySelectorAll('span#dogName').forEach(span => {
        span.textContent = petName;
      });
    });
  }

  // ----------------------------
  // is-filled logic
  // ----------------------------
  document.querySelectorAll('select.input__field').forEach(select => {
    if (select.value) select.classList.add('is-filled');

    select.addEventListener('change', function () {
      select.classList.toggle('is-filled', select.value !== "");
    });
  });

  document.querySelectorAll('input.input__field').forEach(input => {
    if (input.value) input.classList.add('is-filled');

    input.addEventListener('keyup', function () {
      input.classList.toggle('is-filled', input.value !== "");
    });
  });

  // ----------------------------
  // Dynamic Messages
  // ----------------------------
  function updateMessage(selectedValue, type) {
    const messageBoxes = {
      chew: "chewMessage",
      box: "boxMessage",
      footnote: "footnoteMessage",
    };

    const messages = {
      chew: {
        "Light Chewer": "Soft plush & squeaky toys for gentle play.",
        "Moderate Chewer": "The perfect balance of fun and durability.",
        "Tough Chewer": "Built for serious chewers. Ultra-durable rubber & nylon."
      },
      box: {
        "Toys & Treats": "💙 100% Canadian-made treats with simple, clean ingredients.",
        "Toys Only": "🐾 No treats? No problem! We’ve packed in extra toys instead!"
      },
      footnote: {
        "Toys & Treats": "Every DuraPaw Box includes 3 durable toys, premium Canadian treats, plus a themed accessory.",
        "Toys Only": "Every Toys Only Box includes 4 durable toys plus an engaging accessory, built for nonstop play."
      }
    };

    const messageBox = document.getElementById(messageBoxes[type]);
    if (!messageBox) return;

    messageBox.classList.add("fade");

    setTimeout(() => {
      messageBox.innerHTML = messages[type][selectedValue] || "";
      messageBox.classList.remove("fade");
    }, 200);
  }

  // --- Initial State on Page Load ---
  const defaultChew = document.querySelector("input[name='option_two']:checked");
  const defaultBox = document.querySelector("input[name='option_three']:checked");

  if (defaultChew) updateMessage(defaultChew.value, "chew");
  if (defaultBox) {
    updateMessage(defaultBox.value, "box");
    updateMessage(defaultBox.value, "footnote");
  }

  // --- Event Listeners ---
  document.querySelectorAll("input[name='option_two']").forEach(radio => {
    radio.addEventListener("change", function () {
      updateMessage(this.value, "chew");
    });
  });

  document.querySelectorAll("input[name='option_three']").forEach(radio => {
    radio.addEventListener("change", function () {
      updateMessage(this.value, "box");
      updateMessage(this.value, "footnote");
    });
  });

  // ----------------------------
  // Initial Load
  // ----------------------------
  const initialPlan = document.querySelector('input[name="product_plan"]:checked');
  if (initialPlan) {
    loadProductData(initialPlan.value).then(() => {
      updateSellingPlan();
      updateQuizVariants();
    });
  }

  // CUSTOM PIXEL TRACKING FUNCTION -->
  setTimeout(() => {
    publishQuizStep(state.currentStep);
  }, 400);
  // END CUSTOM PIXEL TRACKING FUNCTION -->

});